import { FiX } from "react-icons/fi";

const ClearFiltersButton = ({ onClear, hasActiveFilters }) => {
	if (!hasActiveFilters) return null;

	return (
		<button
			onClick={onClear}
			className="flex max-w-max items-center gap-2 px-3 py-2 text-sm text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-lg transition-colors"
		>
			<FiX size={16} />
			Clear filters
		</button>
	);
};

export default ClearFiltersButton;
